<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <img class="header-bg" src="../assets/img/banner9.jpg" alt="" />
      <div class="navi-container">
        <div class="navi-list">
          <div class="navi-item">
            <a href="gywm_u.html" title="关于我们">关于我们</a>
          </div>
          <div class="navi-item active">
            <a href="zshz_u.html" title="招商合作">招商合作</a>
          </div>
          <div class="navi-item">
            <a href="zxns_u.html" title="招贤纳士">招贤纳士</a>
          </div>
          <div class="navi-item dio">
            <a href="xswd_u.html" title="销售网点">销售网点</a>
          </div>
          <div class="navi-item">
            <a href="zxly_u.html" title="在线留言">在线留言</a>
          </div>
        </div>
      </div>

      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="title">招商加盟</div>
            <div class="bar"></div>
            <div class="tg">农极客与经销商伙伴共赢未来</div>
            <div class="bs-img">
              <img src="../assets/img/business.jpg" alt="" />
            </div>
            <div class="bs-phone">
              <div class="bs-phone-img">
                <img src="../assets/img/business-phone.png" alt />
              </div>
              <pre class="bs-phoen-text">
立即成为农极客代理经销商
开启农资零售新时代</pre
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
// import Like from "../components/likeList.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    // Like,
  },
  data: () => {
    return {
      totalpage: 1,
      currentpage: 1,

      cardType: "0", //0 农技文章,1活动卡片
      cardList: [],
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);
  },
  methods: {
    pageChange(n) {
      console.log(n);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}

.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}

.title {
  font-size: 32px;
  color: #333;
  text-align: center;
  padding: 0 0 6px 0;
  // font-family: "NSimSun";
  font-weight: bold;
}
.bar {
  width: 80px;
  height: 4px;
  margin: -5px auto 15px;
  background: #65b825;
}
.tg {
  font-size: 24px;
  color: #666666;
  text-align: center;
  // font-family: "NSimSun";
  padding-bottom: 34px;
}
.bs-img {
  width: 100%;
  overflow: hidden;
  > img {
    width: 100%;
  }
}
.bs-phone {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  .bs-phone-img {
    img {
      width: 458px;
      height: 66px;
      display: block;
    }
    margin-right: 24px;
  }
  .bs-phoen-text {
    font-size: 18px;
    color: #343434;
    line-height: 24px;
    margin-bottom: 0;
    font-family: "Microsoft YaHei";
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
      //   margin-right: 54px;
    }
  }
}
.navi-container {
  width: 100%;
  height: 64px;
  background: #65b825;
  .navi-list {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #65b825;
    .navi-item {
      width: 240px;
      flex-grow: 1;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 62px;
      position: relative;
      left: -1px;
      a {
        display: block;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 22px;
        color: #fff;
        border-right: 2px solid #fff;
        text-align: center;
      }
      &:last-child a {
        border-color: transparent;
      }
      &:hover {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
      &.active {
        background: #fff;
        margin-left: -2px;
        margin-right: 2px;
        a {
          color: #65b825;
          border-right: transparent;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
    padding-left: 10px;
  }
  .headers {
    width: 100%;
    padding-left: 10px;
  }
  #app {
    overflow: hidden;
  }
  #app .headers .header-nav {
    display: none;
  }
  .navi-container {
    height: 37px;
    .navi-list {
      width: 100%;
      .navi-item {
        height: 36px;
        a {
          font-size: 14px;
        }
      }
    }
  }
  .articleList-container .articleList-content {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    .articleList {
      margin-right: 0;
    }
    .shop-list {
      justify-content: space-around;
      .shop-item {
        width: 40vw;
        margin-right: 0;
        height: 40vw;
        .shop-image {
          width: 40vw;
          height: 40vw;
          .el-image {
            width: 40vw;
            height: 40vw;
          }
        }
        .shop-info {
          width: 40vw;
          height: 30px;
          .shop-title {
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
          }
          .shop-more {
            top: 12px;
            img {
              width: 10px;
              height: 6px;
            }
          }
        }
      }
    }
  }
  .title {
    font-size: 20px;
    padding-top: 30px;
  }
  .bar {
    height: 2px;
  }
  .desc {
    font-size: 14px;
    margin-bottom: 30px;
  }
  .culture {
    align-items: flex-start;
    padding-bottom: 30px;
  }
  .culture .culture-item {
    .culture-title{
      font-size: 16px;
    }
    .culture-desc{
      font-size: 14px;
    }
    img {
      width: 70px;
      height: 70px;
    }
  }
  .history{
    padding-left: 60px;
  }
  .col-bar{
    left: 20px
  }
  .year-item{
    padding: 10px 0;
    .year-box{
      font-size: 15px;
      padding: 20px
    }
  }
  .year-item .year-i{
    left: 20px;
    .y{
      font-size: 16px;
      line-height: 25px;
      width: 50px;
    }
  }
  .map-container{
    flex-direction: column;
  }
  .com-info{
    padding-top: 20px;
  }
  .bs-phone .bs-phone-img img{
    width: 100%;
    height: auto;
  }
  .bs-phone{
    flex-direction: column;
  }
  .tg{
    font-size: 16px;
  }
}
</style>
